import { ActionIcon, Button, Modal, Table, Text } from "@mantine/core";
import {
  IconEdit,
  IconEye,
  IconHistory,
  IconMusicPause,
  IconPlayerPause,
  IconPlayerPlay,
  IconTrash,
  IconTriangle,
} from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { deleteObligation, pauseObligation } from "../apis/userApis";
import {
  converDateToISO,
  convertToISO8601,
  getActFrequencyText,
  getDepartmentText,
} from "./utilities";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getObligationsForAgreement,
  playMasterObligationApi,
} from "../apis/obligationApi";
import { showNotification } from "@mantine/notifications";
import { DatePicker } from "@mantine/dates";

const LegacyAgreementForm3 = ({ setUiConfigs, details }) => {
  const [obligations, setObligations] = useState(null);
  const navigate = useNavigate();
  console.log(details);
  const getObligationsforAgreement = async () => {
    const response = await getObligationsForAgreement({
      local: details.local,
      agreementId: details.agreementId,
    });
    console.log(response);
    setObligations(response.obligations);
  };
  useEffect(() => {
    getObligationsforAgreement();
  }, []);
  console.log(obligations);
  const onViewClick = (id) => {
    navigate(`/viewmasterobligation/${id}`);
  };
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [expandedId, setExpandedId] = useState(null); // Tracks the currently expanded obligation by ID
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [showPlayModal, setShowPlayModal] = useState(false);
  const [playId, setPlayId] = useState(0);
  const [pauseId, setPauseId] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const handleExpand = (id) => {
    setExpandedId(id);
  };

  const deleteMasterObligation = async () => {
    try {
      const response = await deleteObligation({ id: deleteId });
      if (response.success) {
        setDeleteId(0);
        setShowModal(false);
        getObligationsforAgreement();
        setReload(!reload);
      }
    } catch (error) {
      showNotification({
        title: "delete obligation",
        message: "obligation not deleted",
        color: "green",
      });
    }
  };
  const pauseMasterObligation = async () => {
    try {
      const response = await pauseObligation({ id: pauseId });
      if (response.success) {
        setPauseId(0);
        setShowPauseModal(false);
        setReload(!reload);
        showNotification({
          color: "green",
          message: "obligations paused ",
          title: "pause obligation",
        });
      }
    } catch (error) {}
  };
  const playMasterObligation = async () => {
    try {
      const response = await playMasterObligationApi({
        id: playId,
        startDate: startDate,
      });
      if (response.success) {
        setPlayId(0);
        setShowPlayModal(false);
        setReload(!reload);
      } else {
        showNotification({
          title: "play obligation",
          message: "play obligation: not successfull",
          color: "red",
        });
      }
    } catch (error) {}
  };
  console.log("start Date: ", startDate);
  return (
    <div>
      <Modal
        opened={showModal}
        onClose={() => {
          setShowModal(false);
          setDeleteId(0);
        }}
      >
        <div>
          <Text>are you sure you want to delete this obligation ?</Text>
          <div className="flex justify-between mt-4">
            <Button
              onClick={() => {
                setDeleteId(0);
                setShowModal(false);
              }}
              color="gray"
              variant="light"
            >
              Cancel
            </Button>
            <Button onClick={deleteMasterObligation} color="red">
              Delete
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        opened={showPlayModal}
        onClose={() => {
          setShowPlayModal(false);
          setStartDate(null);
          setPlayId(0);
        }}
      >
        <div>
          <Text>play obligation</Text>
          <div>
            <DatePicker
              className="my-3"
              minDate={new Date()}
              maxDate={new Date(details.endDate)}
              placeholder="select start date"
              label="start date"
              value={startDate}
              onChange={(val) =>
                setStartDate(convertToISO8601(converDateToISO(val)))
              }
            />
          </div>
          <div className="flex justify-between mt-4">
            <Button
              onClick={() => {
                setShowPlayModal(false);
                setPlayId(0);
              }}
              color="gray"
              variant="light"
            >
              Cancel
            </Button>
            <Button onClick={playMasterObligation} color="red">
              play
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        opened={showPauseModal}
        onClose={() => {
          setShowPauseModal(false);
          setPauseId(0);
        }}
      >
        <div>
          <Text className="text-base">
            are you sure you want to pause this obligation ?
          </Text>
          <p className="text-red-400 text-sm">
            warning : all the obligations which have due date greater than today
            will be paused.
          </p>
          <div className="flex justify-between mt-4">
            <Button
              onClick={() => {
                setPauseId(0);
                setShowPauseModal(false);
              }}
              color="gray"
              variant="light"
            >
              cancel
            </Button>
            <Button onClick={pauseMasterObligation} color="red">
              pause
            </Button>
          </div>
        </div>
      </Modal>

      <Table>
        <thead className="text-center">
          <tr>
            {/* <th style={{ textAlign: "center" }}>select</th> */}
            <th style={{ textAlign: "center" }}>obligation id {"(m)"}</th>
            <th style={{ textAlign: "center" }}>obligation title</th>
            <th style={{ textAlign: "center" }}>description</th>
            <th style={{ textAlign: "center" }}>act. frequency</th>
            <th style={{ textAlign: "center" }}>department</th>
            <th style={{ textAlign: "center" }}>assigned to</th>
            {/* <th style={{ textAlign: "center" }}> draft </th> */}
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {obligations &&
            obligations.map((row) => (
              <tr key={row.id} className={row.draft ? "bg-orange-200" : ""}>
                {/* <td>
                  <input type="checkbox" />
                </td> */}
                <td>{row.id}</td>
                <td>{row.title}</td>
                <td style={{ textAlign: "center" }}>
                  {expandedId === row.id
                    ? row.desc // Show full description if expanded
                    : row.desc.slice(0, 50)}
                  {/* Truncated description */}
                  {expandedId !== row.id && row.desc.length > 50 && (
                    <span
                      onClick={() => handleExpand(row.id)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      ...
                    </span>
                  )}
                </td>
                <td>{getActFrequencyText(row.actFrequency)}</td>
                <td>{getDepartmentText(row.department)}</td>
                <td>{row.assignTo.name}</td>
                {/* <td>{row.draft? "yes": "no"}</td> */}
                <td>
                  <div className="flex flex-row mr-4">
                    <ActionIcon
                      onClick={() => {
                        onViewClick(row.id);
                      }}
                      color="white"
                    >
                      <IconEye size={24} />
                    </ActionIcon>
                  </div>
                </td>
                <td>
                  {row.actFrequency !== 1 && !row.extraCol3 && (
                    <div className="flex flex-row mr-4">
                      <ActionIcon
                        onClick={() => {
                          setPauseId(row.id);
                          setShowPauseModal(true);
                        }}
                        color="white"
                      >
                        <IconPlayerPause color="orange" size={24} />
                      </ActionIcon>
                    </div>
                  )}
                  {row.actFrequency !== 1 && row.extraCol3 && (
                    <div className="flex flex-row mr-4">
                      <ActionIcon
                        onClick={() => {
                          setPlayId(row.id);
                          setShowPlayModal(true);
                        }}
                        color="white"
                      >
                        <IconPlayerPlay color="orange" size={24} />
                      </ActionIcon>
                    </div>
                  )}
                </td>
                <td>
                  <div className="flex flex-row mr-4">
                    <ActionIcon
                      onClick={() => {
                        setDeleteId(row.id);
                        setShowModal(true);
                      }}
                      color="white"
                    >
                      <IconTrash color="red" size={24} />
                    </ActionIcon>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <div className="flex flex-row justify-between">
        <Button
          style={{
            backgroundColor: "#46BDE1",
          }}
          onClick={() => setUiConfigs({ currentStep: 1 })}
          className="mt-3"
        >
          Previous
        </Button>
        <Button
          style={{
            backgroundColor: "#46BDE1",
          }}
          onClick={() => navigate("/docslocker")}
          className="mt-3"
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default LegacyAgreementForm3;
